module.exports = __webpack_public_path__ + "assets/img/shortsPlatform-banner.1928909f.png";